document.addEventListener('DOMContentLoaded', function () {
  const megaMenu = document.querySelector('[data-custom-mega-menu]');
  if (!megaMenu) return;

  const root = document.documentElement;
  const header =
    document.querySelector('.shopify-section-header') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  const openButton = document.querySelector('[data-custom-mega-open]');
  const closeButton = document.querySelector('[data-custom-mega-close]');
  const drawer = document.querySelector('[data-custom-mega-drawer]');
  const overlay = document.querySelector('[data-custom-mega-overlay]');
  const desktopItems = document.querySelectorAll('.custom-mega-desktop__item');

  function setMegaMenuTop() {
    if (!header) return;

    const rect = header.getBoundingClientRect();
    const bottom = rect.bottom;

    root.style.setProperty('--mega-menu-dynamic-top', `${bottom}px`);
  }

  setMegaMenuTop();

  window.addEventListener('resize', setMegaMenuTop);
  window.addEventListener('scroll', setMegaMenuTop, { passive: true });

  let megaCloseTimer;

desktopItems.forEach(function (item) {
  const panel = item.querySelector('.custom-mega-panel');

  function openItem() {
    clearTimeout(megaCloseTimer);

    desktopItems.forEach(function (otherItem) {
      if (otherItem !== item) {
        otherItem.classList.remove('is-open');
      }
    });

    setMegaMenuTop();
    item.classList.add('is-open');
  }

  function closeItemWithDelay() {
    clearTimeout(megaCloseTimer);

    megaCloseTimer = setTimeout(function () {
      item.classList.remove('is-open');
    }, 220);
  }

  item.addEventListener('mouseenter', openItem);
  item.addEventListener('mouseleave', closeItemWithDelay);

  if (panel) {
    panel.addEventListener('mouseenter', openItem);
    panel.addEventListener('mouseleave', closeItemWithDelay);
  }

  item.addEventListener('focusin', openItem);

  item.addEventListener('focusout', function () {
    megaCloseTimer = setTimeout(function () {
      item.classList.remove('is-open');
    }, 220);
  });
});


  function openMobileMenu() {
    if (!drawer || !overlay || !openButton) return;

    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    document.body.classList.add('custom-mega-menu-open');
    openButton.setAttribute('aria-expanded', 'true');
  }

  function closeMobileMenu() {
    if (!drawer || !overlay || !openButton) return;

    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.body.classList.remove('custom-mega-menu-open');
    openButton.setAttribute('aria-expanded', 'false');
  }

  if (openButton) {
    openButton.addEventListener('click', openMobileMenu);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMobileMenu();
    }
  });
});